// voice-preview.ts — (session 10, drop 114b; owner 11:29) the voice pickers play ElevenLabs' OWN preview (its preview_url),
// loaded from ElevenLabs' preview host. Never our copy (held privately for the licensing audit), never our storage's
// audio/ path. A preview that is missing, not on that host, or no longer loads: the voice is shown without a preview.
export const ELEVENLABS_PREVIEW_HOST = "storage.googleapis.com";

/** The address a picker may play, or null (show the voice without a preview). */
export function playablePreviewUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  let u: URL;
  // catch-reason: a value that isn't a URL is no preview: the voice shows without one
  try { u = new URL(url); } catch { return null; }
  return u.protocol === "https:" && u.host === ELEVENLABS_PREVIEW_HOST ? url : null;
}
